<div class="timekeeping-totals" appBringozIdGenerator="timekeeping-totals">

  @for (card of cards(); track card.status) {
    <button type="button"
            class="totals-card"
            appBringozIdGenerator="timekeeping-totals-card-button"
            [class.totals-card-selected]="card.selected"
            [attr.aria-pressed]="card.selected"
            (click)="statusSelect.emit(card.status)">

      <div class="totals-card-header">
        @if (card.badgeClass) {
          <span class="totals-status-badge" [ngClass]="card.badgeClass">{{ card.labelKey | translate }}</span>
        } @else {
          <span class="totals-label">{{ card.labelKey | translate }}</span>
        }

        @if (card.selected) {
          <div class="totals-filter-btn">
            <bz-icon [icon]="filterIcon" size="sm"></bz-icon>
          </div>
        }
      </div>

      <div class="totals-card-value">
        <span class="br-body-3">{{ card.value }}</span>
      </div>
    </button>
  }

</div>
